module.exports = __webpack_public_path__ + "static/media/18.0f126538.png";